module.exports = __webpack_public_path__ + "img/profile-img-sample.761f069c.png";